module.exports = __webpack_public_path__ + "static/media/react-min.26051d03.jpg";